import {Panes, prefixWithSeparator, TextField} from '@management-ui/core';
import {
  Autocomplete,
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField as MUITextField
} from '@mui/material';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {ServiceContext} from '../../../../components/Services';
import {currencySymbol, joinAddress} from '../../../../utilities';

const Delivery = ({order = {}, prefix = ''}) => {
  const services = useContext(ServiceContext);
  const [customers, setCustomers] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [location, setLocation] = useState('');
  const initialised = useRef(false);
  const {setValue} = useFormContext();

  useEffect(() => {
    if (!initialised.current) {
      initialised.current = true;
      services.contact.getCachedCustomers()
        .then(response => setCustomers(response.data))
        .catch(() => setCustomers([]));
    }
  }, [services]);

  useEffect(() => {
    if (customer) {
      const index = customer.locations.findIndex(({id}) => `${id}` === location);
      if (index >= 0) {
        setValue(`${prefixWithSeparator(prefix)}delivery_address`, joinAddress(customer.locations[index], [customer.name]));
      }
    }
  }, [prefix, customer, location, setValue])

  return (
    <Panes
      entity={order}
      prefix={prefix}
      panes={[
        {
          title: 'Delivery Address',
          fields: [
            <Box marginY={2}>
              <Autocomplete
                options={customers}
                value={customer}
                onChange={(e, selected) => setCustomer(selected)}
                renderInput={(params) => <MUITextField {...params} label="Customer"/>}
                getOptionLabel={(option) => option.name}
              />
            </Box>,
            <Box marginY={2}>
              <FormControl fullWidth disabled={(customer?.locations ?? []).length < 1}>
                <InputLabel id="locationLabel">Location</InputLabel>
                <Select
                  labelId="locationLabel"
                  value={location}
                  label="Location"
                  onChange={(e) => setLocation(e.target.value)}
                >
                  {(customer?.locations ?? []).map((l, i) => (
                    <MenuItem key={i} value={`${l.id}`}>{l.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>,
            <TextField
              name="delivery_address"
              prefix={prefix}
              label="Delivery Address"
              fieldProps={{multiline: true, rows: 4}}
            />,
            <TextField
              name="delivery_cost"
              prefix={prefix}
              label="Cost"
              fieldProps={{
                InputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      {currencySymbol(order.currency)}
                    </InputAdornment>
                  )
                }
              }}
            />,
          ]
        },
        {
          title: 'Delivery Notes',
          fields: [
            <TextField
              name="delivery_notes"
              prefix={prefix}
              label="Notes"
              fieldProps={{multiline: true, rows: 4}}
            />,
          ]
        }
      ]}
      title=""
    />
  );
};

Delivery.onSave = ({delivery_address, delivery_cost, delivery_notes}) => ({
  delivery_address,
  delivery_cost,
  delivery_notes
});

export default Delivery;
